import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=0de1a860"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=0de1a860&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de1a860')) {
      api.createRecord('0de1a860', component.options)
    } else {
      api.reload('0de1a860', component.options)
    }
    module.hot.accept("./LayoutContent.vue?vue&type=template&id=0de1a860", function () {
      api.rerender('0de1a860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/business/LayoutContent.vue"
export default component.exports